<template>
  <div class="schedule-page">
    <div justify="center">
      <v-dialog id="test" v-model="dialog" persistent max-width="600px">
        <EventCreation
          :default-data="selectedDates"
          :dialog="dialog"
          @close="dialog = false"
        >
        </EventCreation>
      </v-dialog>
    </div>

    <v-container fill-height fluid>
      <v-layout align-center justify-center>
        <v-flex xs12 md8>
          <FullCalendar
            ref="fullCalendar"
            :key="schedulerKey"
            class="mb-3"
            default-view="timeGridWeek"
            :plugins="calendarPlugins"
            :events="getEvents"
            long-press-delay="0"
            :business-hours="businessHours"
            now-indicator="true"
            :locale="$i18n.locale"
            :aspect-ratio="aspect"
            scroll-time="09:00:00"
            :select-overlap="selectOverlap"
            :event-limit="3"
            :header="{
              left: 'prev,next,today',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
            }"
            :button-text="buttonsText"
            :all-day-html="$t('scheduler.calendar.all-day-html')"
            event-text-color="#fff"
            :event-render="eventRender"
            @loading="load"
            @eventClick="eventClick"
          />
          <v-container class="pa-0">
            <v-row justify="center">
              <v-spacer v-if="guest"></v-spacer>
              <v-col v-if="guest" cols="3" class="pa-0 text-center">
                <v-btn class="mb-2" outlined @click="back">
                  {{ $t("app.buttons.back") }}
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="3" class="pa-0">
                <v-overlay :value="eventsLoading">
                  <Progression></Progression>
                </v-overlay>
                <div class="text-center">
                  <v-bottom-sheet v-model="menu">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark v-on="on">
                        {{ $t("app.forms.filters") }}
                      </v-btn>
                    </template>
                    <v-sheet class="text-center" height="200px">
                      <h3 class="headline">{{ $t("app.forms.filters") }}</h3>
                      <v-row>
                        <v-col cols="8">
                          <v-row justify="center">
                            <v-col cols="3"></v-col>
                            <v-col class="pa-0" cols="6">
                              <v-checkbox
                                v-model="seeCancelled"
                                class="ma-0"
                                :label="$t('scheduler.calendar.see-cancelled')"
                              ></v-checkbox>
                            </v-col>
                            <v-col cols="3"></v-col>
                            <v-col cols="3"></v-col>
                            <v-col class="pa-0" cols="6">
                              <v-checkbox
                                v-if="isAdmin() && !guest"
                                v-model="seeAll"
                                class="ma-0"
                                :label="$t('scheduler.calendar.see-all')"
                              ></v-checkbox>
                            </v-col>
                            <v-col cols="3"></v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4">
                          <v-row justify="center">
                            <v-col cols="12">
                              <v-btn
                                color="primary"
                                @click="
                                  {
                                    reset();
                                    menu = false;
                                  }
                                "
                                >{{ $t("app.buttons.apply") }}</v-btn
                              >
                            </v-col>
                            <v-col cols="12">
                              <v-btn outlined @click="menu = false">
                                {{ $t("app.buttons.close") }}
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-sheet>
                  </v-bottom-sheet>
                </div>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import $ from "jquery";
import FullCalendar from "@fullcalendar/vue";
import timeGrid from "@fullcalendar/timegrid";
import dayGridPlugin from "@fullcalendar/daygrid";
import interaction from "@fullcalendar/interaction";
import EventCreation from "./Event/EventCreation";
import Popover from "./Popover";
import Progression from "@/components/Progression";
import Vue from "vue";
import { eventBus } from "@/main";

export default {
  components: {
    FullCalendar,
    Progression,
    EventCreation
  },

  data() {
    return {
      eventsLoading: false,
      schedulerKey: 0,
      menu: false,
      events: [],
      calendarPlugins: [dayGridPlugin, timeGrid, interaction],
      seeAll: false,
      seeCancelled: false,
      dialog: false,
      guest: true,
      selectedDates: {
        start: null,
        end: null
      },
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      businessHours: [
        {
          daysOfWeek: [0],
          startTime: "11:00",
          endTime: "17:00"
        },
        {
          daysOfWeek: [1, 2, 3, 4, 5],
          startTime: "10:00",
          endTime: "21:00"
        },
        {
          daysOfWeek: [6],
          startTime: "9:00",
          endTime: "17:00"
        }
      ],
      eventToggles: {}
    };
  },

  computed: {
    // Because the height prop is known for not working
    aspect: function() {
      const bp = this.$vuetify.breakpoint;
      // Percentage of the height to occupy in the available space
      var percentage = 0.85;
      // Start distance of the calendar from the top in pixels
      var startY = 145;
      // The calendar width / window width ratio
      var wRatio = 597 / 929;

      if (bp.xs || bp.sm) {
        startY = 203;
        wRatio = 321 / 360;
        percentage = 0.95;
      }
      return (
        (this.windowWidth * wRatio) /
        (percentage * (this.windowHeight - startY))
      );
    },

    buttonsText: function() {
      return {
        today: this.$t("scheduler.calendar.today"),
        month: this.$t("scheduler.calendar.month"),
        week: this.$t("scheduler.calendar.week"),
        day: this.$t("scheduler.calendar.day"),
        list: this.$t("scheduler.calendar.list")
      };
    }
  },

  watch: {
    eventToggles: {
      handler(val) {
        // Reset the z-index of events when none is selected
        const toggles = Object.entries(val);
        if (toggles.every(toggle => !toggle[1])) {
          $(".fc-time-grid-event").each((i, el) => {
            const z = parseInt(el.style["z-index"]);
            el.style["z-index"] = z >= 1000 ? z - 1000 : z;
          });
        }
      },
      deep: true
    }
  },

  created() {
    let self = this;
    eventBus.$on("redirect", function(route) {
      self.redirect(route);
    });
  },

  mounted() {
    this.$nextTick(async function() {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
      });
      this.guest = this.$route.query.owner || this.$route.query.owner === 0;
    });
  },

  methods: {
    load(val) {
      this.eventsLoading = val;
    },
    // Force the re-rendering of the calendar
    reset() {
      this.schedulerKey++;
    },
    redirect(route) {
      this.$router.push(route);
    },
    permitted() {
      const user = this.$store.getters["site/user"];
      return !!user;
    },

    isAdmin() {
      return this.$store.getters["site/user"].role === "admin";
    },
    canEdit() {
      var role = this.$store.getters["site/user"].role;
      return role === "admin" || role === "teacher";
    },

    getEvents(info, successCallback, failureCallback) {
      let self = this;
      var options = {
        userId: self.guest ? self.$route.query.owner : null,
        seeAll: self.seeAll,
        seeCancelled: self.seeCancelled,
        start: this.dateToString(info.start),
        end: this.dateToString(info.end)
      };
      this.$store
        .dispatch("scheduler/getEvents", options)
        .then(res => success(res))
        .catch(err => {
          failureCallback(err);
        });
      var success = res => {
        var events = res;
        this.fetchParticipations(events, successCallback, failureCallback)
          .then(() => {
            successCallback(events);
          })
          .catch(err => {
            failureCallback(err);
          });
      };
    },

    dateToString(date) {
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return (
        date.getFullYear() +
        "/" +
        (month < 10 ? "0" + month : month) +
        "/" +
        (day < 10 ? "0" + day : day)
      );
    },

    /**
     * Fetch participations for the given events.
     *
     * @method
     * @name fetchParticipations
     * @param { array } events Events from which the participations should be fetched
     */
    async fetchParticipations(events) {
      // Fetch participations of currently loaded events in parallel
      const promises = events.map(this.getEventParticipations);
      return Promise.all(promises);
    },

    /**
     * Extract participations from a single event.
     *
     * @method
     * @name getEventParticipations
     * @param { object } event Event to extract the participations from
     */
    async getEventParticipations(event) {
      return new Promise((resolve, reject) => {
        const notFound = !this.events.some(el => el.eventId == event.id);
        if (notFound) {
          this.$store
            .dispatch("scheduler/getParticipants", event.id)
            .then(res => {
              var ev = {
                id: event.id,
                abstract: event.abstract,
                occurrence: event.occurrence,
                lastOccurrence: event.lastOccurrence,
                participations: res
              };
              this.events.push(ev);
              resolve(res);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },

    dateClick(data) {
      if (this.canEdit()) {
        data.jsEvent.preventDefault();
        this.selectedDates.start = data.date;
        this.selectedDates.end = null;
        this.dialog = true;
      }
    },

    datesSelected(data) {
      if (this.canEdit()) {
        data.jsEvent.preventDefault();
        this.selectedDates.start = data.start;
        this.selectedDates.end = data.end;
        this.dialog = true;
      }
    },

    eventClick(data) {
      data.jsEvent.preventDefault();
      this.toggle(data.event.id);

      // Bring the popover to the top with some necessary JQuery
      const columnSelector = ".fc-event-container, .fc-row";
      const eventSelector = ".fc-time-grid-event, .fc-day-grid-event";
      // Bring back the previously selected event/column
      $(columnSelector + ", " + eventSelector).each((i, el) => {
        const z = parseInt(el.style["z-index"]);
        el.style["z-index"] = z >= 1000 ? z - 1000 : z;
      });
      // Then bring the selected event to the top
      const z = parseInt(data.el.style["z-index"]);
      data.el.style["z-index"] = z >= 1000 ? z : z + 1000;
      // Same with the whole column
      $(data.el)
        .parents(columnSelector)
        .each(function() {
          const z = parseInt(this.style["z-index"] ? this.style["z-index"] : 4);
          this.style["z-index"] = z >= 1000 ? z : z + 1000;
        });
    },

    eventRender(data) {
      const coursesLeft =
        data.event.extendedProps.lastOccurrence -
        data.event.extendedProps.occurrence;
      data.el.href = "";
      let shortenedTitle = data.event.title;
      // Size of a row in characters count (about 9 to 24 characters)
      const rowSize = this.$vuetify.breakpoint.mdAndDown ? 9 : 15;
      // Milliseconds it takes for an event to be the height of a row (about 15 to 30 minutes)
      const rowTimespan = this.$vuetify.breakpoint.mdAndDown
        ? 1000000
        : 1800000;
      // Milliseconds the event lasts
      const eventLength = data.event.end - data.event.start;
      // Maximum number of characters to display the title
      let maxSize = rowSize * (eventLength / rowTimespan - 2);
      if (maxSize < rowSize) {
        maxSize = rowSize;
      }
      if (maxSize < shortenedTitle.length) {
        shortenedTitle = shortenedTitle.slice(0, maxSize - 3) + "...";
      }
      data.el.innerHTML =
        "<div>" +
        shortenedTitle +
        '</div><div class="leftClassesHook">(' +
        coursesLeft +
        ")</div>";
      this.createPopover(data.el, data.event);
    },

    createPopover(element, event) {
      if (typeof this.eventToggles[event.id] === "undefined") {
        this.$set(this.eventToggles, event.id, false);
      }
      var participations;
      this.events.forEach(ev => {
        if (ev.id == event.id) {
          participations = ev.participations;
          event.abstract = ev.abstract;
          event.occurrence = ev.occurrence;
          event.lastOccurrence = ev.lastOccurrence;
        }
      });
      const PopoverClass = Vue.extend(Popover);
      const instance = new PopoverClass({
        propsData: {
          target: element,
          event: event,
          userRole: this.$store.getters["site/user"].role,
          toggles: this.eventToggles,
          participations: participations
        },
        events: {
          redirect: function(param) {
            this.$router.push(param);
          }
        }
      });
      instance.$mount();
      element.appendChild(instance.$el);
    },

    toggle(eventId) {
      // Close all popovers first
      for (var key in this.eventToggles) {
        if (key !== eventId) {
          this.$set(this.eventToggles, key, false);
        }
      }
      this.$set(this.eventToggles, eventId, !this.eventToggles[eventId]);
    },

    /**
     * Used to enable background events selection.
     */
    selectOverlap(event) {
      return (
        event.rendering === "background" ||
        event.rendering === "inverse-background"
      );
    },

    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
@import "~@fullcalendar/timegrid/main.css";
</style>

<style lang="scss">
.leftClassesHook {
  position: absolute;
  bottom: 0px;
}
@media (max-width: 768px) {
  .popover-title {
    font-size: 2em;
  }
  /* Source: jsfiddle.net/Mottie/G6K6Y/1482/ */
  #calendar {
    width: 200px;
    margin: 0 auto;
    font-size: 10px;
  }
  .fc-toolbar {
    font-size: 0.9em;
  }
  .fc-toolbar h2 {
    font-size: 12px;
    white-space: normal !important;
  }
  /* click +2 more for popup */
  .fc-more-cell a {
    display: block;
    width: 85%;
    margin: 1px auto 0 auto;
    border-radius: 3px;
    background: grey;
    color: transparent;
    overflow: hidden;
    height: 4px;
  }
  .fc-more-popover {
    width: 100px;
  }
  .fc-view-month .fc-event,
  .fc-view-agendaWeek .fc-event,
  .fc-content {
    font-size: 8px;
    overflow: hidden;
  }
  .fc-time-grid-event.fc-event,
  .fc-day-grid-event.fc-h-event.fc-event {
    font-size: 0.5em;
  }
  .fc-content .fc-time {
    font-size: 0;
  }
  .fc-view-agendaWeek .fc-event-vert {
    font-size: 0;
    overflow: hidden;
    width: 2px !important;
  }
  .fc-axis {
    width: 40px !important;
    font-size: 0.6em;
  }
  .fc .fc-axis {
    vertical-align: top;
  }
  .fc-row {
    min-height: 0px !important;
  }
  .fc-day-grid {
    height: 30px !important;
  }
  .fc-button-content {
    padding: 0;
  }
  .fc-day-header {
    font-size: 0.6em;
  }
}
</style>
